import DashboardPage from "./container"
import "./style.scss"
/**
 * @module DashboardPage
 * @description 戰情室頁面
 *
 */
export default DashboardPage;